import React from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { Modal, ModalProps } from '../Modal';
import { Button } from '../Button';
import { Tooltip } from '../Tooltip';

const meta: Meta<typeof Modal> = {
  title: 'Components/Modal',
  component: Modal,
};

export default meta;
type Story = StoryObj<typeof Modal>;

function ModalStory(props: Partial<ModalProps>) {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div>
      <Button onClick={() => setIsOpen(true)}>Open Modal</Button>
      <Modal show={isOpen} onRequestHide={() => setIsOpen(false)} {...props} />
    </div>
  );
}

export const Default: Story = {
  render: ModalStory,
  args: {
    title: 'Modal Title',
    closeButton: true,
    closeOnOutsideClick: true,
    children: (
      <div>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio consectetur nam vero recusandae maiores
          corporis, velit quae mollitia reprehenderit odit!
        </p>
      </div>
    ),
  },
};

export const StatusVariants: Story = {
  render(props: Partial<ModalProps>) {
    const [isInfoModalOpen, setIsInfoModalOpen] = React.useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isDangerModalOpen, setIsDangerModalOpen] = React.useState(false);
    const [isWarningModalOpen, setIsWarningModalOpen] = React.useState(false);

    return (
      <div>
        <Modal {...props} show={isInfoModalOpen} onRequestHide={() => setIsInfoModalOpen(false)} status="info" />
        <Modal
          {...props}
          show={isSuccessModalOpen}
          onRequestHide={() => setIsSuccessModalOpen(false)}
          status="success"
        />
        <Modal {...props} show={isDangerModalOpen} onRequestHide={() => setIsDangerModalOpen(false)} status="danger" />
        <Modal
          {...props}
          show={isWarningModalOpen}
          onRequestHide={() => setIsWarningModalOpen(false)}
          status="warning"
        />

        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <Button onClick={() => setIsInfoModalOpen(true)}>Open Info Modal</Button>
          <Button onClick={() => setIsSuccessModalOpen(true)}>Open Success Modal</Button>
          <Button onClick={() => setIsDangerModalOpen(true)}>Open Danger Modal</Button>
          <Button onClick={() => setIsWarningModalOpen(true)}>Open Warning Modal</Button>
        </div>
      </div>
    );
  },
  args: {
    title: 'Modal Title',
    closeButton: true,
    closeOnOutsideClick: true,
    children: (
      <div>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio consectetur nam vero recusandae maiores
          corporis, velit quae mollitia reprehenderit odit!
        </p>
      </div>
    ),
  },
};

export const WithTooltip: Story = {
  render: ModalStory,
  args: {
    title: 'Modal Title',
    closeButton: true,
    closeOnOutsideClick: true,
    children: (
      <div>
        <p style={{ marginBottom: 16 }}>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio consectetur nam vero recusandae maiores
          corporis, velit quae mollitia reprehenderit odit!
        </p>
        <Tooltip contents={<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem, exercitationem!</p>}>
          <Button>Hover Me</Button>
        </Tooltip>
      </div>
    ),
  },
};
